<template>
  <v-container fluid>
    <modal-eliminar :objModalEliminar="objModalEliminar"></modal-eliminar>
    <v-row>
      <div class="col-12">
        <router-link exact="" style="text-decoration: none" :to="{ name: 'inicioPanel' }" >Inicio</router-link > /
        <router-link exact="" style="text-decoration: none" :to="{ name: 'opticasPanel' }" >opticas</router-link >
      </div>

      <v-col cols="12">
        <v-card class="" elevation="" max-width="">
          <v-card-title class="justify-center"> GESTIONAR OPTICAS </v-card-title>
          <v-separador></v-separador>
          <v-card-text>
            <v-row>
              <v-col xl="6" lg="6" md="6" sm="6" cols="6">
                <v-row>
                  <v-col>
                    <v-select
                      v-model="cmbCantidadRegistros"
                      item-text="texto"
                      item-value="valor"
                      :items="arrCantidadRegistros"
                      label="Cantidad de registros"
                      @change="listarRegistros()"
                      dense
                      outlined
                    ></v-select>
                  </v-col>

                  <v-col cols="12" md="2">
                    <v-btn
                      small
                      :loading="btnReporteExcel"
                      fab
                      depressed
                      elevation=""
                      @click="reporteExcel()"
                    >
                      <v-icon large color="success">mdi-file-excel</v-icon>
                    </v-btn>
                  </v-col>

                  <v-col cols="12" md="2">
                    <v-btn
                      small
                      title="Limpiar filtros"
                      fab
                      dark
                      color="blue-grey"
                      depressed
                      @click="limpiarFiltros()"
                    >
                      <v-icon dark>mdi-refresh</v-icon>
                    </v-btn>
                  </v-col>

                  

                </v-row>

              </v-col>
              <v-col xl="6" lg="6" md="6" sm="6" cols="6" class="text-right">
                <v-btn
                  v-show="validarPermiso('opticas.crear')"
                  :to="{ name: 'opticasCrearPanel' }"
                  color="primary"
                  dark
                  large=""
                >
                  <v-icon left="" large="">mdi-plus-circle</v-icon> NUEVA OPTICA
                </v-btn>
              </v-col>

              <v-col cols="12" v-show="arrRegistrosTabla.length > 0">
                <v-simple-table dense="" fixed-header="" ref="tblListado">
                  <template v-slot:default>
                    <thead class="text-no-wrap">
                      <tr>
                        <th>ACCIONES</th>
                        <th>CIUDAD</th>
                        <th>NOMBRES</th>
                        <!-- <th>¿EN "+ visitados" ?</th> -->
                        <!-- <th>POSICIÓN (+ visitados)</th> -->
                        <th>DIRECCIÓN</th>
                        <th>REFERENCIA</th>
                        <th>PRECIO</th>
                        <th>HORARIO</th>
                        <!-- <th>MOSTRAR</th> -->
                      </tr>
                    </thead>
                    <tbody class="text-no-wrap">
                      <tr v-for="item in arrRegistrosTabla" :key="item.idoptica">
                        <td>
                          <v-menu offset-y>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                small
                                dark=""
                                depressed=""
                                color="cyan"
                                v-bind="attrs"
                                v-on="on"
                              >
                                <v-icon left="">mdi-cursor-default-click</v-icon>
                                Acciones
                              </v-btn>
                            </template>
                            <v-list>
                              <v-list-item
                                v-show="validarPermiso('opticas.editar')"
                                :to="{
                                  name: 'opticasEditarPanel',
                                  params: { idoptica: item.idoptica },
                                }"
                              >
                                <v-list-item-title>
                                  <v-icon>mdi-pencil</v-icon> Editar
                                </v-list-item-title>
                              </v-list-item>

                              <v-list-item
                                v-show="validarPermiso('opticas.eliminar')"
                                @click="
                                  objModalEliminar = {
                                    idoptica: item.idoptica,
                                    openModal: true,
                                  }
                                "
                              >
                                <v-list-item-title>
                                  <v-icon>mdi-trash-can</v-icon> Eliminar
                                </v-list-item-title>
                              </v-list-item>
                            </v-list>
                          </v-menu>
                        </td>
                        <td v-text="(item.ciudad || '--')+' / '+(item.distrito || '--')"></td>
                        <td v-text="item.nombre"></td>
                        <!-- <td v-text="item.en_top_5 ? 'SI' : 'NO'"></td> -->
                        <!-- <td v-text="item.en_top_5"></td> -->
                        <td v-text="item.direccion"></td>
                        <td v-text="item.referencia"></td>
                        <td v-text="item.precio_examen"></td>
                        <td v-text="item.horario"></td>
                        <!-- <td v-text="item.mostrar ? 'SI' : 'NO'"></td> -->
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>

                <p>
                  Mostrando del registro <span v-text="primerRegistro"></span> al
                  <span v-text="ultimoRegistro"></span> de un total de
                  <span v-text="totalRegistro"></span> filas
                </p>
              </v-col>

              <v-col cols="12 text-center" v-show="loaderListado">
                <v-progress-circular
                  indeterminate
                  color="primary"
                  :size="100"
                  :width="7"
                ></v-progress-circular>
              </v-col>

              <v-col cols="12" v-show="arrRegistrosTabla.length > 0">
                <v-pagination
                  circle
                  v-model="paginaActual"
                  :length="cantidadoptica"
                  :total-visible="7"
                  @input="
                    listarRegistros()
                  "
                  :disabled="loaderListado"
                ></v-pagination>
              </v-col>

              <v-col cols="12" v-show="alertRegistroNoEcontrado">
                <v-alert type="error" dense outlined class="text-center">
                  NO HAY REGISTROS DISPONIBLES PARA MOSTRAR
                </v-alert>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import modalEliminar from "./Eliminar";
export default {
  components: {
    modalEliminar,
  },
  data() {
    return {
      arrCantidadRegistros: [
        {
          texto: 10,
          valor: 10,
        },
        {
          texto: 30,
          valor: 30,
        },
        {
          texto: 50,
          valor: 50,
        },
        {
          texto: 100,
          valor: 100,
        },
        {
          texto: 500,
          valor: 500,
        },
      ],
      loaderListado: false,
      alertRegistroNoEcontrado: false,
      cmbCantidadRegistros: 10,
      arrRegistrosTabla: [],
      paginaActual: 1,
      cantidadoptica: 1,
      primerRegistro: 0,
      ultimoRegistro: 0,
      totalRegistro: 0,
      iptBuscarRegisro: "",
      objModalEliminar: null,
      objModalDetalleProducto: null,
      btnReporteExcel: false,
    };
  },

  methods: {
    listarRegistros() {

      this.arrRegistrosTabla = [];
      this.loaderListado = true;
      this.alertRegistroNoEcontrado = false;

      this.axios({
        method: "GET",
        url: "api/panel/opticas",
        params: {
          cantidadRegistros: this.cmbCantidadRegistros,
          paginaActual: this.paginaActual,
          iptBuscarRegisro: this.iptBuscarRegisro,
        },
      })
        .then((response) => {
          let listado = response.data.data;

          this.arrRegistrosTabla = listado.data;
          this.paginaActual = listado.current_page;
          this.cantidadoptica = listado.last_page;
          this.primerRegistro = listado.from;
          this.ultimoRegistro = listado.to;
          this.totalRegistro = listado.total;

          if (this.arrRegistrosTabla.length === 0) {
            this.alertRegistroNoEcontrado = true;
          } else {
            this.alertRegistroNoEcontrado = false;
          }
        })
        .catch((error) => {
          console.log(error.response);
        })
        .finally(() => {
          this.loaderListado = false;
          this.$vuetify.goTo(this.$refs.tblListado);
        });
    },

    reporteExcel() {
      window.open(this.apiUrl("api/panel/opticas/reporteExcel"), "_self");

      /*this.btnReporteExcel = true;
      this.axios({
        method: "POST",
        url: "api/panel/opticas/reporteExcel",
        responseType: "blob",
      })
        .then((response) => {
          let status = response.status;
          if (status === 200) {
            let objUrl = URL.createObjectURL(response.data);
            const link = document.createElement("a");
            link.setAttribute("href", objUrl);
            link.setAttribute(
              "download",
              "reporte_opticas_" + this.$moment().format("DD-MM-YYYY_hh-mm-ss")
            );
            link.click();
          }
        })
        .catch((error) => {
          console.log(error);
        })
        .then(() => {
          this.btnReporteExcel = false;
        });*/
    },

    limpiarFiltros() {
      this.cmbCantidadRegistros = 10;
      this.iptBuscarRegisro = "";
      this.listarRegistros();
    },
  },

  created() {
    if (!this.validarPermiso("opticas.listado")) {
      this.$toasted.error("Usted no tiene permisos para esta sección", {
        icon: "mdi-close",
      });

      this.$router.push({
        name: "inicioPanel",
      });
    }
    this.listarRegistros();
  },
};
</script>
